// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Footer-module---container---2dsTv","content":"src-components----Footer-module---content---3zeuG","contact":"src-components----Footer-module---contact---27cin","visit":"src-components----Footer-module---visit---2QnSo","illustration":"src-components----Footer-module---illustration---3GzRN","credits":"src-components----Footer-module---credits---1BQuG","madeWithLove":"src-components----Footer-module---madeWithLove---2hXx6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.module.css
// module id = 123
// module chunks = 35783957827783 43201937662106